<!--
 * @Descripttion:
 * @Author: zenghua.wang
 * @Date: 2021-04-13 10:00:56
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-02-10 16:51:35
-->
<template>
  <el-form
    class="widget-canvas"
    :class="data.list.length == 0 ? 'empty' : ''"
    :label-position="data.labelPosition || 'right'"
    :label-width="setPx(data.labelWidth) || '100px'"
    :label-suffix="data.labelSuffix || ''"
    ref="widgetCanvas"
  >
    <draggable
      class="el-row widget-canvas-list"
      :list="data.list"
      :group="{ name: 'form' }"
      ghost-class="ghost"
      :scroll="true"
      :animation="300"
      @add="onWidgetAdd"
    >
      <el-col
        v-for="(widget, index) in data.list"
        class="widget-canvas-item"
        :md="widget.option.span || 24"
        :xs="24"
        :offset="widget.option.offset || 0"
        :key="index"
        @click.native="onSelectWidget(index)"
      >
        <div
          class="widget-canvas-item__content"
          :style="styleInline(widget)"
        >
          <!-- 动态组件 -->
          <component
            :is="`drag-${widget.type}`"
            :id="widget.prop"
            :label="widget.label"
            :apiId="widget.apiId"
            :width="widget.width"
            :height="widget.height"
            :option="widget.option"
            :children="widget.children"
            :temp="widget.temp"
            :page="widget.page"
            :index="index"
            :disabled="false"
            :select.sync="selectWidget"
            @change="$emit('change')"
          ></component>

          <div
            v-if="selectWidget.prop == widget.prop"
            class="widget-canvas-item__action"
          >
            <el-button
              title="上移"
              @click.stop="onWidgetMove(widget, index, 'up')"
              circle
              plain
              size="small"
              type="primary"
            >
              <i class="el-icon-top"></i>
            </el-button>

            <el-button
              title="下移"
              @click.stop="onWidgetMove(widget, index, 'down')"
              circle
              plain
              size="small"
              type="primary"
            >
              <i class="el-icon-bottom"></i>
            </el-button>

            <el-button
              title="复制"
              @click.stop="onWidgetClone(index)"
              circle
              plain
              size="small"
              type="primary"
            >
              <i class="el-icon-document-copy"></i>
            </el-button>

            <el-button
              title="删除"
              @click.stop="onWidgetDelete(index)"
              circle
              plain
              size="small"
              type="danger"
            >
              <i class="el-icon-delete"></i>
            </el-button>
          </div>
        </div>
      </el-col>
    </draggable>
  </el-form>
</template>
<script>
import draggable from 'vuedraggable'
import { component } from '@/dragComponents/model/default.js'
import { createId, deepClone } from '@/dragComponents/utils'

export default {
  name: 'widget-canvas',
  components: {
    draggable
  },
  inject: ['main'],
  props: ['data', 'select'],
  data() {
    return {
      selectWidget: this.select
    }
  },
  computed: {
    styleInline() {
      return (item) => {
        let block = (component.inlineList || []).includes(item.type)
          ? 'inline-block'
          : 'block'
        return {
          display: block
        }
      }
    }
  },
  watch: {
    select(val) {
      this.selectWidget = val
    },
    selectWidget: {
      handler(val) {
        this.$emit('update:select', val)
      },
      deep: true
    }
  },
  methods: {
    onWidgetAdd(e) {
      let newIndex = e.newIndex
      const item = deepClone(this.data.list[newIndex])
      if (!item.prop) item.prop = createId(item.type)
      this.$set(this.data.list, newIndex, item)

      this.$nextTick(() => {
        this.$emit('change')
        this.onSelectWidget(newIndex)
      })
    },
    onSelectWidget(index) {
      this.selectWidget = this.data.list[index]
    },
    onWidgetDelete(index) {
      this.$confirm(`是否删除所选组件?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // 删除
          this.$nextTick(() => {
            this.data.list.splice(index, 1)
            this.$emit('change')
          })
          // 处理active
          if (this.data.list.length - 1 === index) {
            if (index === 0) this.selectWidget = {}
            else this.onSelectWidget(index - 1)
          } else this.onSelectWidget(index + 1)
        })
        .catch(() => {})
    },
    onWidgetClone(index) {
      let cloneData = deepClone(this.data.list[index])
      const type = cloneData.type
      cloneData.prop = createId(type)
      this.data.list.splice(index, 0, cloneData)
      this.$nextTick(() => {
        this.$emit('change')
        this.onSelectWidget(index + 1)
      })
    },
    onWidgetMove(row, index, direction) {
      let len = this.data.list.length
      let stop = direction === 'up' ? 0 : len - 1
      if (index === stop) return
      let next = direction === 'up' ? index - 1 : index + 1
      let temp = this.data.list[next]
      this.$set(this.data.list, index, temp)
      this.$set(this.data.list, next, row)
      this.$emit('change')
      this.onSelectWidget(next)
    }
  }
}
</script>
